export const ROLES = Object.freeze({
  SENDER: "sender",
  RECEIVER: "receiver",
});

export const KYBSTATUS = Object.freeze({
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING"
});

export const DEFAULT_PAGE_SIZE_LIMIT = 10;
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];

// Preset options for the reusable <DateFilter /> component.
export const DATE_FILTER_OPTIONS = Object.freeze({
  MONTH_TILL_DATE: "MTD",
  LAST_MONTH: "Last Month",
  LAST_90_DAYS: "Last 90 Days",
});

export const OTC_STATUS_OPTIONS = Object.freeze({
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  OTC_QUOTE_SHARED: "OTC_QUOTE_SHARED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED",
  EXPIRED: "EXPIRED"
});

export const TRANSACTION_STATUS_OPTIONS = Object.freeze({
  PENDING: "pending",
  CREATED: "created",
  PROCESSING: "processing",
  SUCCESS: "success",
  COMPLETED: "completed",
  WITHDRAWN: "withdrawn",
  FAILED: "failed",
  REJECTED: "rejected",
});

// Vendors backing a getVaultBalance() vault entry — PRIMEVAULT is crypto (token-balance
// ledger shape), CREDIBLE is fiat (transaction ledger shape).
export const VAULT_VENDOR = Object.freeze({
  PRIMEVAULT: "PRIMEVAULT",
  CREDIBLE: "CREDIBLE",
});
